export enum InputSizeType {
  DEFAULT = '',
  LARGE = 'large',
}

export enum SelectOptionType {
  DEFAULT = '',
  WARNING = 'warning',
}
